
import { GameManager } from "../GameManager";
import { AudioManager } from "../AudioManager";
import { GameConstants } from "../GameConstants";
import { GameVars } from "../GameVars";
import { GameTitle } from "./GameTitle";

export class PreloadScene extends Phaser.Scene {

    public static currentInstance: PreloadScene;

    private progressBar: Phaser.GameObjects.Graphics;

    constructor() {

        super("PreloadScene");

        PreloadScene.currentInstance = this;
    }

    public preload(): void {

        this.composeScene();

        this.loadAssets();
    }

    public create(): void {

        this.loadHowl();
    }
    
    private composeScene(): void {

        this.add.text(-100, -100, "abcdefg", { fontFamily: "Supercell", fontSize: 28, color: "#A6F834" });
        this.add.text(-100, -100, "abcdefg", { fontFamily: "Oswald-SemiBold", fontSize: 28, color: "#A6F834" });

        const gameTitle = new GameTitle(this);
        gameTitle.x = GameConstants.GAME_WIDTH / 2 + 14;
        gameTitle.alpha = 0;
        gameTitle.y = 160 * GameVars.scaleY;
        this.add.existing(gameTitle);

        this.tweens.add({
            targets: gameTitle,
            alpha: 1,
            ease: Phaser.Math.Easing.Cubic.Out,
            duration: 1000,
        });

        const scaledItemsContainer = this.add.container(GameConstants.GAME_WIDTH / 2, GameConstants.GAME_HEIGHT / 2 + 130 * GameVars.scaleY);
        scaledItemsContainer.scaleY = GameVars.scaleY;

        const barWidth = 450;
        const barWHeight = 16;
        const borderWidth = 3;

        const preloadBarCapsuleBorder = new Phaser.GameObjects.Graphics(this);
        preloadBarCapsuleBorder.fillStyle(0x015e80);
        preloadBarCapsuleBorder.fillRect(0, 0, barWidth + borderWidth * 2, barWHeight + borderWidth * 2);
        preloadBarCapsuleBorder.x = - barWidth / 2 - borderWidth;
        preloadBarCapsuleBorder.y = -borderWidth;
        scaledItemsContainer.add(preloadBarCapsuleBorder); 

        const preloadBarCapsule = new Phaser.GameObjects.Graphics(this);
        preloadBarCapsule.fillStyle(0x555555);
        preloadBarCapsule.fillRect(0, 0, barWidth, barWHeight);
        preloadBarCapsule.x = - barWidth / 2;
        scaledItemsContainer.add(preloadBarCapsule); 

        this.progressBar = new Phaser.GameObjects.Graphics(this);
        this.progressBar.fillStyle(0xFFFFFF);
        this.progressBar.fillRect(0, 0, barWidth, barWHeight);
        this.progressBar.x = - barWidth / 2;
        this.progressBar.scaleX = 0;
        scaledItemsContainer.add(this.progressBar); 
    }

    private loadAssets(): void {

        this.load.atlas("texture_atlas_1", "assets/texture_atlas_1.png", "assets/texture_atlas_1.json");

        // EL TEXTO DEL JUEGO
        this.load.json("game-text", "assets/config/text.json");

        // fuentes
        this.load.bitmapFont("supercell-white", "assets/fonts/supercell-white.png", "assets/fonts/supercell-white.xml");
        this.load.bitmapFont("supercell-green", "assets/fonts/supercell-green.png", "assets/fonts/supercell-green.xml");
        this.load.bitmapFont("supercell-red", "assets/fonts/supercell-red.png", "assets/fonts/supercell-red.xml");

        this.load.json("sound", "assets/audio/sound.json");
        this.load.json("music", "assets/audio/music.json");

        this.load.on("progress", this.updateLoadedPercentage, this);
    }

    private updateLoadedPercentage(percentageLoaded: number): void {

        if (this.progressBar.scaleX < percentageLoaded) {
            this.progressBar.scaleX = percentageLoaded;
        }
    }

    private loadHowl(): void {

        let musicJson = this.cache.json.get("music");
        musicJson = JSON.parse(JSON.stringify(musicJson).replace("urls", "src"));

        AudioManager.music = new Howl(musicJson);
    
        AudioManager.music.on("load", function() {

            let soundJson = PreloadScene.currentInstance.cache.json.get("sound");
            soundJson = JSON.parse(JSON.stringify(soundJson).replace("urls", "src"));

            AudioManager.sound = new Howl(soundJson);

            AudioManager.sound.on("load", function() {

                GameManager.setCurrentScene(PreloadScene.currentInstance);
                PreloadScene.currentInstance.scene.setVisible(false);
                GameManager.onGameAssetsLoaded();
            });
        });
    }
}
